module.exports = __webpack_public_path__ + "images/store_case_study/jungle-pic1_444926a66860d593c46e2924aca1d00e.png";